export default {
    url: '/equipments_power',
    template: require('./view.html'),
    data: {
        title: 'Equipments power',
        priority: 900,
    },
    reloadOnSearch: false,
};
